if($('.type-category').length){
    $('.category-top').wrapInner('<div class="container"></div>').addClass('top-cat').insertAfter('header#header')
    //$('#content-wrapper').before('<section class="top-category"><div class="container"><div class="title"></div><div class="description"></div><div class="subkat"></div></div></section>')
    /*var findtitle = $('main#content h1')
    var finddescription = $('main#content .category-perex:not(".empty-content")')
    var findcategory = $('main#content .subcategories')
    $('.top-category .container .title').html(findtitle)
    $('.top-category .container .description').html(finddescription)
    $('.top-category .container .subkat').html(findcategory)
    $('#productsTop').appendTo('.top-category .container')*/
    mhperex();


   
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        $('.top-category .container .title').html($('main#content h1'))
      
        mhperex();

    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        $('.top-category .container .title').html($('main#content h1'))
       
        mhperex();

    });
}

if($('.pagination-wrapper').length){
    $('.pagination-wrapper').each(function(){
        if($(this).find('.pagination-loader').length == 0){
            $(this).addClass('emptydiv')
        }
    })
}


function mhperex(){
    $('.category-perex').each(function(){
         cleim_tag = '#bottom-description#';
         cleim_identifier = 'p:contains('+cleim_tag+')';
         if($(cleim_identifier).length){
            if($('.cat-perex-bottom').length == 0){
             $('footer#footer').before('<div class="cat-perex-bottom"><div class="container"></div></div>')
             var element = $(cleim_identifier).nextAll()
             var elementwrap = $(element).wrapAll('<div class="wrap"></div>')
             $(elementwrap).appendTo('.cat-perex-bottom .container')
             $(cleim_identifier).remove()
            }
           
         }
    });
}

